import { useUiStore } from 'app/core/store_v2/ui';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import PaymentStatusInfo from '../payment/payment-status-info/PaymentStatusInfo';

/**
 * Listens for certificate payment status in URL hash or via props and displays payment status info accordingly.
 * @param props
 * @returns
 */
export default function PaymentStatusListener() {
  const { stripeCertificatePaymentState } = useUiStore();
  const [status, setStatus] = useState<string | null>(null);
  const [searchParams] = useSearchParams();

  if (!searchParams.has('payment')) {
    return null;
  }

  const paramStatus = searchParams.get('payment');
  if (paramStatus && paramStatus === 'cancel' && status !== 'cancel') {
    setStatus('cancel');
    console.log('set status to cancel');
  } else if (status !== 'cancel' && stripeCertificatePaymentState && status !== stripeCertificatePaymentState) {
    setStatus(stripeCertificatePaymentState);
  }

  return <PaymentStatusInfo status={status ?? 'pending'} />;
}
